export default "__VITE_ASSET__Sg6RdC8I__"